import React, { useEffect, useState, useRef, KeyboardEvent } from 'react';
import SVGComp from '../widget/w-svg';
import TextMsg from '../widget/common/textMessage';

interface TextInputProps {
  className: string;
  type: string;
  id?: string;
  value: string;
  onChange?: (value: string) => void;
  ariaLabel?: string;
  placeholder?: string;
  prefixSvgId?: string;
  prefixsvgClass?: string;
  prefixid?:  string;
  prefixtooltipId?: string;
  prefixtooltipText?: string;
  prefixtooltipPosition?: string;
  prefixhandleImageClick?: () => void;
  prefixhandleImageHover?: () => void;
  suffixSvgId?: string;
  suffixsvgClass?: string;
  suffixId?: string;
  suffixtooltipId?: string;
  suffixtooltipText?: string;
  suffixtooltipPosition?: string;
  suffixhandleImageClick?: () => void;
  suffixhandleImageHover?: () => void;
  prefixTabIndex?: number;
  suffixTabIndex?: number;
  handleAction?: () => void;
  handleChangeAction?: () => void;
  handleBlur?: () => void;
  focusElement?: boolean;
  autofocus?: boolean;
  inputref?: React.RefObject<HTMLInputElement>;
  texterror?: string;
  tabIndex?: number;
  maxLength?: number;
  inputLabel?: string;
  disabled?:  boolean;
  errorspace?:  boolean;
  textInputLabel?: string;
  minLimit?: number;
  maxLimit?: number;
  errorDisplay?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const TextInput: React.FC<TextInputProps> = ({
  className,
  type,
  id,
  value,
  onChange,
  tabIndex,
  ariaLabel,
  placeholder,
  prefixid,
  prefixSvgId,
  prefixsvgClass,
  prefixtooltipId,
  prefixtooltipText,
  prefixtooltipPosition,
  prefixhandleImageClick,
  prefixhandleImageHover,
  prefixTabIndex,
  suffixId,
  suffixSvgId,
  suffixsvgClass,
  suffixtooltipId,
  suffixtooltipText,
  suffixtooltipPosition,
  suffixhandleImageClick,
  suffixhandleImageHover,
  suffixTabIndex,
  handleAction,
  handleBlur,
  handleChangeAction,
  focusElement,
  autofocus,
  inputref,
  texterror,
  maxLength,
  inputLabel,
  disabled,
  errorspace,
  textInputLabel,
  minLimit,
  maxLimit,
  errorDisplay,
  onKeyDown,
}) => {
  useEffect(() => {});

  const [prevValue, setPrevValue] = useState(value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;

    if (type === 'number' && newValue !== '') {
      const numValue = Number(newValue);

      if (!isNaN(numValue)) {
        if (minLimit !== undefined && numValue < minLimit) {
          newValue = minLimit.toString();
        }
        if (maxLimit !== undefined && numValue > maxLimit) {
          newValue = prevValue;
        }
      }
    }

    setPrevValue(newValue);
    onChange(newValue);
    if (handleChangeAction) {
      handleChangeAction();
    }
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (handleAction) {
        handleAction();
      }
    }
    if (onKeyDown) {
      onKeyDown(e);
    }
  };
  const handleFocus = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (focusElement) {
      e.target.select();
    }
  };

  return (
    <div>
      {textInputLabel && (
        <div className='position-absolute name_border_css'>
          <span className='t-d-59 text_caption_bold'>{textInputLabel}</span>
        </div>
      )}
      <div className='d-flex align-items-center position-relative'>
        {prefixSvgId && (
          <div className='position-absolute ps-3 start-0'>
            <SVGComp
              SvgId={prefixSvgId}
              svgClass={prefixsvgClass}
              tooltipId={prefixtooltipId}
              tooltipText={prefixtooltipText}
              tooltipPosition={prefixtooltipPosition}
              show
              handleImageClick={prefixhandleImageClick}
              handleImageHover={prefixhandleImageHover}
              svgtabIndex={prefixTabIndex}
              id={prefixid}
            />
          </div>
        )}
        <input
          className={
            (prefixSvgId
              ? className + ' ps-5 '
              : suffixSvgId
              ? className + ' pe-5 '
              : className)
           
          }
          type={type}
          id={id}
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyPress}
          aria-label={ariaLabel}
          placeholder={placeholder}
          ref={inputref}
          onFocus={handleFocus}
          autoFocus={autofocus}
          tabIndex={tabIndex}
          onBlur={handleBlur}
          disabled={disabled}
          {...(type === 'number' && { min: minLimit || 0, max: maxLimit || Number.MAX_SAFE_INTEGER })}
        />
        {suffixSvgId && (
          <div className='position-absolute pe-3 end-0'>
            <SVGComp
              SvgId={suffixSvgId}
              svgClass={suffixsvgClass}
              tooltipId={suffixtooltipId}
              tooltipText={suffixtooltipText}
              tooltipPosition={suffixtooltipPosition}
              handleImageClick={suffixhandleImageClick}
              handleImageHover={suffixhandleImageHover}
              svgtabIndex={suffixTabIndex}
              id={suffixId}
              show
            />
          </div>
        )}
      </div>
      {texterror ? (
        <div
          className={'error-inlinetext' + (errorDisplay ? ' position-absolute pt-1' : ' ')}
          role='alert'
          aria-atomic='true'
          id='error-text'
        >
          {value?.length > maxLength ? (
            <>{`${inputLabel} ${TextMsg.maxLengthError} ${maxLength}`}</>
          ) : (
            <>{texterror}</>
          )}
        </div>
      ) : (
        <>{errorspace && <div className='hidden-text p-font'>.</div>}</>
      )}
    </div>
  );
};

export default TextInput;
